<template>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        >
        <path
            d="M10 18.3333C5.975 18.3333 2.70833 15.0667 2.70833 11.0417C2.70833 7.01667 5.975 3.75 10 3.75C14.025 3.75 17.2917 7.01667 17.2917 11.0417"
            :stroke="iconColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M10 6.66699V10.8337"
            :stroke="iconColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M7.5 1.66699H12.5"
            :stroke="iconColor"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M15.8334 14.167V17.5003"
            :stroke="iconColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M13.3334 14.167V17.5003"
            :stroke="iconColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        </svg>
  </template>
  <script setup>
  import { defineProps, inject } from 'vue';
  
   const $filters = inject('$filters');

  const props = defineProps({
    color: {
      type: String,
      default: null,
    },
  });
  
   const iconColor = props.color || $filters.iconColor();
  </script>
